/*jshint esversion:6 */
import React from "react";
// import Moment from 'moment';
// import Permissions from '../../../configurations/permissions';
import ATable from "../../common/table";
// import Constants from '../../../configurations/constants';
// import CButton from '../../common/connectedButton';

const SettlementsTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => (
        <div>{props.paginatedCallBack(row.viewIndex, row.index)}</div>
      )
    },
    {
      header: "Log code",
      accessor: "logCode",
      render: row => {
        return row.row.logCode;
      },
      width: 90
    },

    {
      header: " Settlement Date",
      accessor: "settlementDate",
      render: row => {
        return row.row.settlementDate;
      }
    },
    {
      header: " Settlement Type",
      accessor: "settlementType",
      render: row => {
        return row.row.settlementType;
      }
    },
    {
      header: " Participant",
      accessor: "participant",
      render: row => {
        return row.row.participant;
      }
    },
    {
      header: "Role",
      accessor: "role",
      render: row => {
        return row.row.role;
      }
    },
    {
      header: "Amount",
      accessor: "amount",
      render: row => {
        return row.row.amount;
      }
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.settlements}
      columns={columns}
      onChange={props.onTableChange || null}
      onRowClick={() => null}
      {...props}
    />
  );
};

export default SettlementsTable;



// WEBPACK FOOTER //
// ./src/components/settlement/settlements/settlementsTable.js